// DRAFT answers: marked on the site for founder review.
export const FAQS = [
  {
    id: "timeline",
    q: "How long does it take?",
    a: "Most sites go live 7–10 days after you approve your free mockup. If your project is bigger, we'll tell you the timeline up front, before any work begins.",
  },
  {
    id: "ownership",
    q: "Who owns the site?",
    a: "You do. Your domain, your content, and your website belong to your business. If you ever move on, we'll help you take everything with you.",
  },
  {
    id: "editing",
    q: "Can I edit it myself?",
    a: "Yes. We can set you up to change simple things like hours, photos, and text. Or just send us the change and we'll handle it for you on a care plan.",
  },
  {
    id: "after-launch",
    q: "What happens after launch?",
    a: "We stay on hand. Care plans cover updates, backups, and small edits so your site keeps working. You can reach us anytime with questions.",
  },
];
